export enum OnDemandRouteStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

/** Its `stop_id` belongs to the route: it never designates a stop of the GTFS feed. */
export interface OnDemandStop {
  stop_id: string;
  stop_name: string;
  stop_lat: number;
  stop_lon: number;
}

/** A line served on request: fixed stops, no trip, no shape, no timetable. */
export interface OnDemandRoute {
  route_id: string;
  route_short_name: string;
  route_long_name: string;
  route_color: string;
  route_text_color: string;
  status: OnDemandRouteStatus;
  /** YYYY-MM-DD */
  valid_from: string;
  /** YYYY-MM-DD */
  valid_until: string;
  /** In the order they are served. */
  stops: OnDemandStop[];
}
